import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
declare var FB: any;
@Injectable({
  providedIn: 'root'
})
export class FacebookService {
  private initialized = false;
  // true when SDK loaded and initialized successfully
  private fbAvailable = false;

  constructor( @Inject(PLATFORM_ID) private platformId: any) {}

  initFacebookSDK(app:string, version:string) {
    if (isPlatformBrowser(this.platformId)) {
      return new Promise<void>((resolve) => {
        if (this.initialized) {
          resolve();
          return;
        }

        // If FB already present on the window, use it
        if ((window as any).FB) {
          this.initialized = true;
          this.fbAvailable = true;
          resolve();
          return;
        }

        let timeout: any = null;

        (window as any).fbAsyncInit = () => {
          try {
            FB.init({
              appId: app,
              xfbml: true,
              version: version
            });
            this.initialized = true;
            this.fbAvailable = true;
          } catch (e) {
            // If FB exists but init throws, consider SDK not available
            this.fbAvailable = false;
          }

          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          // Always resolve so app can continue even if FB is blocked
          resolve();
        };

        const js = document.createElement('script');
        js.id = 'facebook-jssdk';
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        js.onerror = () => {
          // Script failed to load (network blocked / blocked by policy)
          this.fbAvailable = false;
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          // Resolve so the app doesn't wait on FB
          resolve();
        };
        document.head.appendChild(js);

        // Fallback timeout: if script doesn't load in X ms, resolve anyway
        timeout = setTimeout(() => {
          this.fbAvailable = false;
          timeout = null;
          resolve();
        }, 5000); // 5s timeout (adjustable)
      });
    } else  {
      return new Promise<void>((resolve) => {
        resolve();
      });
    }

  }

  loginWithFacebook(): Promise<{ firstName: string; lastName: string; email: string; authToken: string }> {
    return new Promise((resolve, reject) => {
      // Ensure we're in browser and FB SDK was loaded
      if (!isPlatformBrowser(this.platformId)) {
        reject(new Error('Facebook login is only available in the browser'));
        return;
      }

      if (!this.fbAvailable || typeof FB === 'undefined') {
        // Fail fast - caller can show alternate UI or message
        reject(new Error('Facebook SDK not available'));
        return;
      }

      FB.login((response: any) => {
        if (response && response.authResponse) {
          const authToken = response.authResponse.accessToken;
          FB.api('/me', { fields: 'first_name,last_name,email' }, (profile: any) => {
            if (profile && !profile.error) {
              resolve({
                firstName: profile.first_name,
                lastName: profile.last_name,
                email: profile.email,
                authToken,
              });
            } else {
              reject(new Error('No se pudo obtener el perfil de Facebook'));
            }
          });
        } else {
          reject(new Error('Facebook login cancelled or failed'));
        }
      }, { scope: 'public_profile,email' }); // Agrega permisos requeridos aquí
    });
  }
}
